import { useEffect, useState } from 'react';
import type { ReportReason } from '@brainfart/shared';
import { API_BASE } from './apiBase';

export type ReportMode = 'solo' | 'daily' | 'multiplayer';
export interface ReportTarget { questionId: string; prompt: string; mode: ReportMode; picked?: string | null }

// One report popup for the whole app, mounted at the root, so it survives the
// screen underneath changing (multiplayer rounds move on by themselves).
let target: ReportTarget | null = null;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach(l => l());

export function openReport(t: ReportTarget) {
  target = t;
  notify();
}

export function closeReport() {
  target = null;
  notify();
}

export function useReportTarget(): ReportTarget | null {
  const [, rerender] = useState(0);
  useEffect(() => {
    const l = () => rerender(n => n + 1);
    listeners.add(l);
    return () => { listeners.delete(l); };
  }, []);
  return target;
}

export async function submitReport(t: ReportTarget, reason: ReportReason, comment: string): Promise<void> {
  let playerId = localStorage.getItem('bf_player_id');
  if (!playerId) {
    playerId = crypto.randomUUID();
    localStorage.setItem('bf_player_id', playerId);
  }
  const res = await fetch(`${API_BASE}/api/questions/report`, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({ questionId: t.questionId, reason, comment: comment.trim() || null, playerId, mode: t.mode, picked: t.picked ?? null }),
  });
  if (!res.ok) throw new Error(`report ${res.status}`);
}
